import { Link } from "react-router-dom";
import { Stack } from "@altimateai/lego";
import { Button, Typography } from "@altimateai/lego";
import { IconUserPlus } from "@tabler/icons-react";

function InviteBox() {
  return (
    <Stack
      direction="column"
      align="center"
      gap="md"
      className="al-p-5 al-rounded-xl al-bg-gradient-to-br al-from-blue-500 al-to-blue-700 al-shadow-lg sm:al-flex-row sm:al-justify-between"
    >
      <Stack direction="column" align="center" gap="sm" className="sm:al-flex-row sm:al-gap-4">
        <div className="al-p-3 al-rounded-full al-bg-white/90 al-shrink-0">
          <IconUserPlus size={32} className="al-text-blue-600" />
        </div>
        <Stack direction="column" gap="xs" className="al-text-center sm:al-text-left">
          <Typography variant="section-heading" className="al-text-white">
            Invite User
          </Typography>
          <Typography size="sm" className="al-text-white/95">
            Invite your team members to collaborate and accelerate the work together
          </Typography>
        </Stack>
      </Stack>
      <Button
        variant="secondary"
        className="al-w-full al-px-8 al-transition-transform hover:al-scale-105 sm:al-w-auto al-shrink-0"
        asChild
      >
        <Link to="/settings/users" state={{ invite: true }}>
          Invite
        </Link>
      </Button>
    </Stack>
  );
}

export default InviteBox;
